import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { PortalService } from '../../../../services/portal/portal.service';
import { map } from 'rxjs/operators';
import { PortalType } from '../../../../models/enum/shared/portal-type';
import { DateUtils } from '../../../../utils/date-utils';

@Component({
  selector: 'app-variable-benefit-payment-amounts-card',
  templateUrl: './variable-benefit-payment-amounts-card.component.html',
  styleUrls: ['./variable-benefit-payment-amounts-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class VariableBenefitPaymentAmountsCardComponent {
  @Input({ required: true }) annualMinimum!: number;
  @Input() isAnnualMinimumEstimated = false;
  @Input({ required: true }) estimatedAnnualTotal!: number;
  @Input() nextYearEstimatedAnnualTotal: number | null = null;
  @Input({ required: true }) isLoading!: boolean;
  @Input() showError = false;
  @Input() nextYear = DateUtils.currentYearInCST() + 1;

  private portalService = inject(PortalService);

  public annualMinimumTooltip$ = this.portalService.portalType$.pipe(
    map(portalType => {
      switch (portalType) {
        case PortalType.Member:
          return $localize`Your required annual minimum payment, determined by your Variable Benefit Account's starting balance and minimum age selection.`;
        default:
          return $localize`The minimum total payment amount required for the year, based on the Variable Benefit Account balance at the start
    of the year and the selected minimum age.`;
      }
    })
  );
}
